import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl, Tabs, Tab, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import ProgramPage from './ProgramPage';
import ErrorComponent from '../components/ErrorComponent'

const creationType = [
  "CNPJ"
];

const defaultChronogram = {
  dtProgramStart: null,
  dtProgramEnd: null,
  dtPurchaseStart: null,
  dtPurchaseEnd: null,
  dtTotalReturnStart: null,
  dtTotalReturnEnd: null,
  dtPurchaseHistoryStart: null,
  dtPurchaseHistoryEnd: null,
  dtHistoryRetPurchaseStart: null,
  dtHistoryRetPurchaseEnd: null,
  dtPromoBudgetPlanEnd: null,
  dtValidityPoints: null,
  dateLimitAcceptance: null,
  dateLimitPromoFunds: null
};

export default class ProgramDetailPage extends PageComponent {
  static PageInfo = {

    path: "/Program/Detail/:id",
    parent: ProgramPage,
    name: "menu.program",
    access: { 1: true, 2: true },
    permission: { "PROGRAM_ACCESS": true },
    icon: "chart-line",
    hidden: true
  }


  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.isModalVisible = null;
    this.state.selectedType = null;
    this.state.modalError = null;
    this.state.selectedBrand = null;
    this.state.changed = false;
    this.state.label = null;
    this.state.goal = null;
    this.state.selectionType = "name";
    this.state.filter = "";
    this.state.doc = null;
    this.state.region = null;
    this.state.city = null;
    this.state.name = null;
    this.state.selectedClient = null;
    this.state.selectedRule = null;
    this.state.file = null;
    this.state.observation = null;
    this.state.form = null;
    this.state.tabmode = "home";
    this.state.hierarchy = null;
    this.state.productGroupDevolutionId = null;
    this.state.fkClientType = null;
    this.state.datetimeRegister = null;
    this.state.promotionalBudgetTypeId = null;
  }

  componentDidMount() {
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Detail/")
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false, status: data.program.programStatusElement[0] }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  addNewFile() {
    this.setState({ modalLoading: true });

    var data = new FormData()
    data.append('title', this.state.label);
    data.append('file', this.state.file.files[0]);
    data.append('observation', this.state.observation);

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/File",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => {
            this.state.data.program.storageProgramElement.push(t);
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  addNewFileResult() {
    this.setState({ modalLoading: true });

    var data = new FormData()
    data.append('file', this.state.file.files[0]);

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/ProgramResultsDetails",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200){
          this.openModal("confirmresult")
          response.json.parse([]).then(t => {
            this.state.data.program.storageProgramElement.push(t);
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
          });
        }
        else {
          this.setState({ modalError: response, modalLoading: false });
          this.openModal("confirmnotresult")
        }
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  addNew(target) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id,
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(target)
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.state.data.program = target;
          this.setState({ modalLoading: false, isModalVisible: null, changed: false });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  addGoal() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.state.selectedClient.customerCode,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ goal: this.state.goal, stateGroup: this.state.selectedStateGroup, franchisee: { mainCompany: { keyRegister: this.state.selectedFranchisee.detail.customerCode } } })
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          var l = ("/Program/Detail/" + this.data.id + "/Goal/" + this.state.selectedClient.customerCode);
          this.setState({ modalLoading: false, isModalVisible: null },
            () => this.props.history.push(l));
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  saveRule(target) {
    var state = this.state.isModalVisible;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Rule" + (this.state.selectedRule != null ? "/" + this.state.selectedRule.id : state == "mainrule" ? "/true" : ""),
      {
        "method": this.state.selectedRule != null ? "PUT" : "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(target)
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          if (this.state.selectedRule != null) {
            this.updateRule(GenericHelper.copyProperties(target, this.state.selectedRule), state);
          } else {
            response.json().then(d => this.updateRule(d, state));
          }
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  updateRule(target, state) {
    if (state == "mainrule")
      this.state.data.primaryRule = target;
    else if (this.state.selectedRule == null)
      this.state.data.secondaryRules.push(target);
    //   this.state.data.secondaryRules.splice(this.state.data.secondaryRules.indexOf(this.state.selectedRule), 1, target);
    this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
  }

  deleteRule(target) {
    var selected = this.state.selectedRule;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Rule/" + selected.id,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(target)
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.state.data.secondaryRules.splice(this.state.data.secondaryRules.indexOf(selected), 1);
          this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  changeStatus() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Status",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ programStatus: { keyConstant: this.state.status.programStatus.keyConstant < 3 ? 3 : 6 } })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => this.setState({ modalLoading: false, isModalVisible: null, status: t }));

        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  updateValues() {
    var o = JSON.parse(JSON.stringify(this.state.data.program));
    for (var i in this.state.form)
      o[i] = this.state.form[i];
    // this.setState({ data: this.state.data, isModalVisible: null, changed: true });
    this.addNew(o);
  }


  parseDate(t) {
    t = t.split('/');
    return t[2] + "-" + t[1] + "-" + t[0] + "T00:00:00";
  }

  changeDropdown(target) {
    this.setState({ selectionType: target, filter: "" });
  }

  openModal(target, props) {
    var v = {};
    this.state.selectedRule = null;
    props = typeof props === "object" && props != null ? props : {};
    props.isModalVisible = target;
    props.modalInitializing = false;
    props.modalError = null;
    props.modalLoading = false;
    this.currentState = {};
    if (target == "date") {
      v = JSON.parse(JSON.stringify(defaultChronogram));
      this.setValues(v);
    } else if (target == "rule" || target == "mainrule") {
      if (target == "mainrule" && this.state.data.primaryRule != null) props.selectedRule = this.state.data.primaryRule;
      var loadedRule = { unit: null, relationship: null, products: null, attribute: null, actionPlan: null, programRulePrizeType: null };
      //campaign: null,
      Connection.Secure(Connection.service + 'Brand/' + this.state.data.program.brand.keyConstant + '/Product')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "products", data, "loadedRule");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
      Connection.Secure(Connection.service + 'ProgramRulePrizeType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "programRulePrizeType", data, "loadedRule");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
      Connection.Secure(Connection.service + 'Attribute')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "attribute", data, "loadedRule");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
        Connection.Secure(Connection.service + 'Actionplan')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "actionPlan", data, "loadedRule");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
      // Connection.Secure(Connection.service + 'Campaign')
      //   .then((response) => {
      //     if (response.ok && response.status == 200)
      //       response.json().then((data) => {
      //         this.doneLoading(loadedRule, "campaign", data, "loadedRule");
      //       });
      //     else this.setState({ error: response, modalInitializing: false });
      //   })
      //   .catch((error) => {
      //     this.setState({ error: error, modalInitializing: false });
      //   });
      Connection.Secure(Connection.service + 'UnitType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "unit", data, "loadedRule");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
      Connection.Secure(Connection.service + 'ProductRelationship')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedRule, "relationship", data, "loadedRule");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    } else if (target == "goal") {
      var loadedGoal = { billing: null, period: null, };
      Connection.Secure(Connection.service + 'ProgramBillingType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedGoal, "billing", data, "loadedGoal");
            });
          else this.setState({ error: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ error: error, modalInitializing: false });
        });
      Connection.Secure(Connection.service + 'ProgramPeriodType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedGoal, "period", data, "loadedGoal");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    } else if (target == "franchisee") {
      var loadedState = { stateGroup: null, };
      Connection.Secure(Connection.service + "StateGroup/List/" + this.state.data.program.brand.keyConstant)
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedState, "stateGroup", data, "loadedState");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    } else if (target == "qaward") {

      var loadedQa = { payment: null, qatype: null };
      Connection.Secure(Connection.service + 'ProgramPaymentType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedQa, "payment", data, "loadedQa");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });

      Connection.Secure(Connection.service + 'QualitativeAwardType')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedQa, "qatype", data, "loadedQa");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    } else if (target == "select") {
      var loadedSelect = { types: null, states: null };

      Connection.Secure(Connection.service + 'Customer/Types')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedSelect, "types", data, "loadedSelect");
            });
          else this.setState({ error: response, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error, loading: false });
        });

      Connection.Secure(Connection.service + 'State/List/')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              this.doneLoading(loadedSelect, "states", data, "loadedSelect");
            });
          else this.setState({ modalError: response, modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalError: error, modalInitializing: false });
        });
      props.modalInitializing = true;
    }
    props.form = v;
    props.file = null;
    props.label = null;
    props.observation = null;
    this.setState(props);
  }


  doneLoading(loaded, target, value, result) {
    if (this.state.modalError == null) {
      loaded[target] = value;

      for (var i in loaded)
        if (loaded[i] == null) return;

      loaded.modalInitializing = false;
      setTimeout(() => this.setState({ modalInitializing: false, [result]: loaded }));
    }
  }

  loadClients() {
    this.setState({ costumerLoading: true, clients: null });
    Connection.Secure(Connection.service + "Program/" + this.data.id + "/Clients",
      {
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ costumerLoading: false, clients: data });
          });
        else this.setState({ costumerLoading: false });
      })
      .catch((error) => {
        this.setState({ costumerLoading: false });
      });
  }

  loadFranchisee(target) {
    this.setState({ selectedStateGroup: { keyConstant: target }, selectedFranchisee: null, loadingFranchisee: null });
    Connection.Secure(Connection.service + "Franchisee/" + target,
      {
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ loadingFranchisee: data });
          });
        else this.setState({ loadingFranchisee: null });
      })
      .catch((error) => {
        this.setState({ loadingFranchisee: null });
      });
  }

  chooseClient(t) {
    this.setState({ modalLoading: true, selectedClient: t });
    Connection.Secure(Connection.service + "Program/" + this.data.id + "/Client/" + t.customerCode + "?check=true",
      {
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          var l = ("/Program/Detail/" + this.data.id + "/Goal/" + t.customerCode);
          this.setState({ modalLoading: false, isModalVisible: null },
            () => this.props.history.push(l));
        } else if (response.status == 404)
          Connection.Secure(Connection.service + "StateGroup/List/" + this.state.data.program.brand.keyConstant,
            {
              "headers": {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            })
            .then((response) => {
              if (response.ok && response.status == 200) {
                response.json().then(data =>
                  this.setState({ modalLoading: false, goal: null, isModalVisible: "newgoal", statesgroups: data })
                )
              } else this.setState({ modalLoading: false, isModalVisible: null });
            })
            .catch((error) => {
              this.setState({ modalLoading: false });
            });
        else this.setState({ modalLoading: false, isModalVisible: null });
      })
      .catch((error) => {
        this.setState({ modalLoading: false });
      });
  }

  searchClients() {
    this.setState({ costumerLoading: true, clientList: [] });
    Connection.Secure(Connection.service + "CustomerFK/List/" + (true || this.state.data.program.fkClientType == null ? this.state.selectedType : this.state.data.program.fkClientType) + "/" + this.state.data.program.hierarchy,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          city: this.state.city, name1: this.state.selectionType == "name" ? this.state.filter : null, customerCode: this.state.selectionType == "customercode" ? this.state.filter : null,
          cnpjCode: this.state.selectionType == "docnumb" ? this.state.filter : null, region: this.state.region
        })

      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.setState({ costumerLoading: false, clientList: data });
          });
        else this.setState({ costumerLoading: false });
      })
      .catch((error) => {
        this.setState({ costumerLoading: false });
      });
  }

  deleteItem() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/File/" + item.id,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            this.state.data.program.storageProgramElement.splice(this.state.data.program.storageProgramElement.indexOf(item), 1);
          } catch (e) { }
          this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data });
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  deleteProgram() {
    var item = this.state.selectedItem;
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service +
      "Program/" + this.data.id,
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          this.props.history.replace('/');
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }

  renderChronogram() {
    var v = JSON.parse(JSON.stringify(defaultChronogram)), l = null, h = 0;
    this.getValues(v);
    for (var i in v) {
      if (v[i] > h) h = v[i];
      if (l == null || l > v[i]) l = v[i];
    }

    if (l != null) {

      var months, d1 = new Date(l), d2 = new Date(h);
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      months = months <= 0 ? 0 : months + 1;
      var l_m = [], l_y = d1.getFullYear(), l_yc = 0;
      for (let i = d1.getMonth(); i < months + d1.getMonth(); i++) {
        if (i % 12 == 0 && i != i < months + d1.getMonth()) l_yc++;
        l_m.push({ "m": Parsers.parseMonthShort(i % 12), "y": l_y + l_yc, i: i - d1.getMonth() });
      }

      d1.setDate(1);
      l = d1.getTime();

      d2.setMonth(d2.getMonth() + 1, 1);
      d2.setHours(0, 0, 0, -1);
      h = d2.getTime();

      h = h - l;
      return <div style={{ padding: 20, border: "1px solid rgb(200,200,200)", borderRadius: 10, marginBottom: 10, marginTop: 10 }}>
        <div style={{ height: 361, position: "relative", marginTop: 193 }}>
          <div style={{ position: "absolute", left: 0, right: 0, height: 81, backgroundColor: "#ffffff", border: "1px solid #cbcbcb" }}>
            {
              l_m.map(t =>
                <div style={{ position: "absolute", left: ((100 / l_m.length) * t.i) + "%", borderLeft: "1px solid #cbcbcb", fontSize: 10, top: -16, bottom: 0 }}>
                  <div className="hide_on_portrait" style={{ paddingLeft: 2 }}>{t.m}</div>
                  {t.i == 0 || (t.i + d1.getMonth()) % 12 == 0 ? <div style={{ position: "absolute", marginTop: -13, top: 0, fontWeight: "bold", borderLeft: "1px solid #cbcbcb", marginLeft: -1, paddingLeft: 2 }}>{t.y}</div> : null}
                </div>
              )}
          </div>
          {this.renderChronogramLine(Labels.GetLabel("program_schedule.histdev"), Labels.GetLabel("program_schedule.histdev"), v.dtHistoryRetPurchaseStart, v.dtHistoryRetPurchaseEnd, h, l, 9, "rgb(34, 179, 38)")}
          {this.renderChronogramLine(Labels.GetLabel("program_schedule.histbui"), Labels.GetLabel("program_schedule.histbui"), v.dtPurchaseHistoryStart, v.dtPurchaseHistoryEnd, h, l, 8, "rgb(26, 115, 61)")}
          {this.renderChronogramLine(Labels.GetLabel("program_schedule.devtotal"), Labels.GetLabel("program_schedule.devtotal"), v.dtTotalReturnStart, v.dtTotalReturnEnd, h, l, 7, "#0000ff")}
          {this.renderChronogramLine(Labels.GetLabel("program_schedule.buy"), Labels.GetLabel("program_schedule.buy"), v.dtPurchaseStart, v.dtPurchaseEnd, h, l, 6, "rgb(41, 157, 255)")}
          {this.renderChronogramLine(Labels.GetLabel("program_schedule.program"), Labels.GetLabel("program_schedule.program"), v.dtProgramStart, v.dtProgramEnd, h, l, 5, "rgb(255, 133, 10)")}
          {this.renderChronogramLine2(Labels.GetLabel("program_schedule.qa"), v.dtPromoBudgetPlanEnd, h, l, 4, "rgb(62, 101, 189)")}
          {this.renderChronogramLine2(Labels.GetLabel("program_schedule.points"), v.dtValidityPoints, h, l, 3, "rgb(117, 85, 15)")}
          {this.renderChronogramLine2(Labels.GetLabel("program_schedule.launch"), v.dateLimitPromoFunds, h, l, 2, "rgb(80, 80, 80)")}
          {this.renderChronogramLine2(Labels.GetLabel("program_schedule.accept"), v.dateLimitAcceptance, h, l, 1, "rgb(30, 21, 84)")}
        </div>
      </div>;
    } return null;
  }

  renderChronogramLine(l1, l2, r1, r2, h, l, t, c) {
    var ml = ((r1 - l) / h) * 100, sl1 = new Date(r1);
    var mr = 100 - ((r2 - l) / h) * 100, sl2 = new Date(r2);
    var ht = 15, hs = 8;
    return <div style={{ position: "relative", backgroundColor: c, }}>
      <div style={{ position: "absolute", right: 0, whiteSpace: "nowrap", left: ml + "%", display: "flex", flexDirection: "row-reverse", borderLeft: "1px solid " + c, height: (t - 3) * (ht + hs) + (t - 1) * hs + 34, marginTop: (-(t - 3) * (ht + hs)) - 34, fontSize: 12 }}><div style={{ flex: 1 }}></div><div><span style={{ marginLeft: -1, padding: 3, backgroundColor: c, color: "white" }}>{l1 + " (" + Parsers.parseDoubleDigit(sl1.getDate()) + "/" + Parsers.parseDoubleDigit(sl1.getMonth() + 1) + "/" + Parsers.parseDoubleDigit(("" + sl1.getFullYear()).substring(2, 4)) + ")"}</span></div></div>
      <div style={{ position: "absolute", backgroundColor: c, height: hs, marginTop: (t - 1) * hs, left: ml + "%", right: mr + "%" }}></div>
      <div style={{ position: "absolute", whiteSpace: "nowrap", left: 0, textAlign: "right", right: mr + "%", borderRight: "1px solid " + c, paddingTop: (t - 3) * ht + ht * (8), marginTop: (t - 1) * hs, fontSize: 12 }}><span style={{ marginRight: -1, padding: 3, backgroundColor: c, color: "white" }}>{l2 + " (" + Parsers.parseDoubleDigit(sl2.getDate()) + "/" + Parsers.parseDoubleDigit(sl2.getMonth() + 1) + "/" + Parsers.parseDoubleDigit(("" + sl2.getFullYear()).substring(2, 4)) + ")"}</span></div>
    </div>;
  }

  renderChronogramLine2(l1, r1, h, l, t, c) {
    var mr = 100 - ((r1 - l) / h) * 100, sl1 = new Date(r1);
    var ht = 15, hs = 8;
    return <div style={{ position: "relative", backgroundColor: c, }}>
      <div style={{ position: "absolute", backgroundColor: c, height: hs, marginTop: (t - 1) * hs, width: 5, right: mr + "%" }}></div>
      <div style={{ position: "absolute", whiteSpace: "nowrap", left: 0, textAlign: "right", right: mr + "%", borderRight: "1px solid " + c, paddingTop: (t - 3) * ht + ht * (8), marginTop: (t - 1) * hs, fontSize: 12 }}><span style={{ marginRight: -1, padding: 3, backgroundColor: c, color: "white" }}>{l1 + " (" + Parsers.parseDoubleDigit(sl1.getDate()) + "/" + Parsers.parseDoubleDigit(sl1.getMonth() + 1) + "/" + Parsers.parseDoubleDigit(("" + sl1.getFullYear()).substring(2, 4)) + ")"}</span></div>
    </div>;
  }

  getValues(v) {
    for (var i in v)
      v[i] = (new Date(this.state.data.program[i])).getTime();
  }

  setValues(t) {
    for (var i in t) {
      if (typeof this.state.data.program[i] === "string" && this.state.data.program[i].length > 0) {
        var v = this.state.data.program[i].split("T")[0].split("-");
        t[i] = Parsers.parseDoubleDigit(v[2]) + "/" + Parsers.parseDoubleDigit(v[1]) + "/" + Parsers.parseDoubleDigit(v[0]);
      }
    }
  }

  selectFranchisee(data, target) {
    if (Array.isArray(data))
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        if (element.detail.customerCode == target) return element;

      }
    return null;
  }

  onTabChange(t) {
    this.setState({ tabmode: t }, () => {

      if (t == "clients" && (this.state.clients == null || this.state.clients.length == 0))
        this.loadClients();
    });
  }

  validatesQualitativeAward() {
    return this.state.data.program.programPaymentType != null && this.state.data.program.qualitativeAwardType != null && this.state.data.program.qualitativeAwardMultiplier != null;
  }

  validatesProgramGoal() {
    return this.state.data.program.programBillingType != null && this.state.data.program.programPeriodType != null && this.state.data.program.percentageGrowth != null && this.state.data.program.minimumBilling != null &&
      this.state.data.program.valuePoint != null;
  }

  renderClients() {
    if (this.state.data.purchasingGoal == null || this.state.data.purchasingGoal.length == 0)
      return <div className="generic_empty">{Labels.GetLabel("generic.noresultfound")}</div>
    else {
      return this.state.data.purchasingGoal.map(item =>
        <Link onClick={() => {
          var l = ("/Program/Detail/" + this.data.id + "/Goal/" + item.detail.customerCode);
          this.setState({ modalLoading: false, isModalVisible: null },
            () => this.props.history.push(l));
        }} className="generics_listing_item" >
          <FontAwesomeIcon icon={
            item.purchasingGoalStatusElement.programStatus.keyConstant == 1 || item.purchasingGoalStatusElement.programStatus.keyConstant == 2 ? "question-circle" :
              item.purchasingGoalStatusElement.programStatus.keyConstant == 3 ? "info-circle" :
                item.purchasingGoalStatusElement.programStatus.keyConstant == 4 ? "clock" :
                  item.purchasingGoalStatusElement.programStatus.keyConstant == 5 ? "clock" :
                    item.purchasingGoalStatusElement.programStatus.keyConstant == 6 ? "user-clock" :
                      item.purchasingGoalStatusElement.programStatus.keyConstant == 9 ? "ban" :
                        item.purchasingGoalStatusElement.programStatus.keyConstant == 10 ? "check-circle" : "times-circle"
          } className="generics_listing_item_icon" color={
            item.purchasingGoalStatusElement.programStatus.keyConstant == 1 || item.purchasingGoalStatusElement.programStatus.keyConstant == 2 ? "#dcb71a" :
              item.purchasingGoalStatusElement.programStatus.keyConstant == 3 ? "#dc551a" :
                item.purchasingGoalStatusElement.programStatus.keyConstant == 4 ? "#1a8fdc" :
                  item.purchasingGoalStatusElement.programStatus.keyConstant == 5 ? "#1a8fdc" :
                    item.purchasingGoalStatusElement.programStatus.keyConstant == 6 ? "#1adc9a" :
                      item.purchasingGoalStatusElement.programStatus.keyConstant == 10 ? "#1adc25" : "#982828"
          } style={{ opacity: 1 }} />
          <div className="generics_listing_content" >
            <div className="generics_listing_item_title" >{item.detail.name1}</div>
            <div className="generics_listing_item_description" >{Parsers.parseCPNJ(item.detail.cnpjCode)}</div>
            <div className="generics_listing_item_description" style={{ textAlign: "right", fontWeight: "bold" }} >{Labels.GetLabel("generic.goal")}: {item.purchasingGoal.goal}</div>
            <div className="generics_listing_item_description" style={{ textAlign: "right" }} >{Labels.GetLabel("STATUS_PROGRAM." + item.status.programStatus.keyConstant)}</div>
          </div>
        </Link>);
    }
  }

  renderGoals() {
    if (this.state.data.purchasingGoal == null || this.state.data.purchasingGoal.length == 0)
      return <div className="generic_empty">{Labels.GetLabel("generic.noresultfound")}</div>
    else {
      var g = {}, r = [];
      for (let i = 0; i < this.state.data.purchasingGoal.length; i++) {
        if (typeof g[this.state.data.purchasingGoal[i].purchasingGoalStatusElement[0].programStatus.keyConstant] === "undefined")
          g[this.state.data.purchasingGoal[i].purchasingGoalStatusElement[0].programStatus.keyConstant] = [];
        g[this.state.data.purchasingGoal[i].purchasingGoalStatusElement[0].programStatus.keyConstant].push(this.state.data.purchasingGoal[i]);
      }
      for (var i in g) r.push({ keyConstant: i, data: g[i] });
      return <div>
        <div>Total: {this.state.data.purchasingGoal.length}</div>
        {
          r.map(t => <div>
            <div>{Labels.GetLabel("STATUS_PROGRAM." + t.keyConstant)}: {t.data.length}</div>
          </div>)
        }
      </div>
    }
  }

  currentState = {};
  findSelected(target, ls, prop, value) {
    for (let i = 0; i < ls.length; i++)
      if (ls[i][prop][value] == target[value])
        return i;
    return -1;
  }
  renderProductSelector(field, leftitems, prop, value) {

    var currentState = this.currentState[field] = typeof this.currentState[field] === "object" ? this.currentState[field] : {
      leftSelection: [],
      rightSelection: [],
      targetField: Array.isArray(this.state.form[field]) ? this.state.form[field] : this.state.selectedRule != null ? JSON.parse(JSON.stringify(this.state.selectedRule[field])) : [],
      products: leftitems
    };

    if (!Array.isArray(currentState.targetField)) currentState.targetField = [];
    if (currentState.targetField != this.state.form[field])
      this.state.form[field] = currentState.targetField;

    return <Form.Group >
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", maxHeight: 200 }}>
          <Form.Label className="form-label">{Labels.GetLabel("generic.available")}</Form.Label>
          <div style={{ flex: 1, border: "1px solid rgb(200,200,200)", overflow: "auto" }}>
            {
              this.state.form && currentState.products.filter(t => this.findSelected(t, currentState.targetField, prop, value) < 0).map(t =>
                <div key={t.id} className={"generics_selectable_item" + (currentState.leftSelection.indexOf(t) < 0 ? "" : " selected")}
                  onClick={(e) => {
                    if (currentState.leftSelection.indexOf(t) > -1) {
                      e.currentTarget.classList.remove("selected");
                      currentState.leftSelection.splice(currentState.leftSelection.indexOf(t), 1);
                    } else {
                      e.currentTarget.classList.add("selected");
                      currentState.leftSelection.push(t);
                    }
                    this.setState({ form: this.state.form });
                  }}
                  onDoubleClick={() => {
                    if (currentState.leftSelection.indexOf(t) > -1)
                      currentState.leftSelection.splice(currentState.leftSelection.indexOf(t), 1);
                    currentState.targetField.push({ [prop + ""]: t });
                    this.setState({ form: this.state.form });
                  }}>
                  {t.label}
                </div>)
            }
          </div>
        </div>
        <div style={{ padding: 10, marginTop: 20, fontSize: 25 }}>
          <div className="generics_selectable_action" onClick={() => {
            for (let i = 0; i < currentState.leftSelection.length; i++)
              currentState.targetField.push({ [prop + ""]: currentState.leftSelection[i] });
            currentState.leftSelection = [];
            this.setState({ form: this.state.form });
          }}>
            <FontAwesomeIcon icon="chevron-circle-right" />
          </div>
          <div className="generics_selectable_action" style={{ marginTop: 20 }} onClick={() => {
            for (let i = 0; i < currentState.rightSelection.length; i++)
              currentState.targetField.splice(currentState.targetField.indexOf(currentState.rightSelection[i]), 1);
            currentState.rightSelection = [];
            this.setState({ form: this.state.form });
          }}>
            <FontAwesomeIcon icon="chevron-circle-left" />
          </div>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column", maxHeight: 200 }}>
          <Form.Label className="form-label">{Labels.GetLabel("generic.selected")}</Form.Label>
          <div style={{ flex: 1, border: "1px solid rgb(200,200,200)", overflow: "auto" }}>
            {
              currentState.targetField.sort(function (a, b) {
                if (a[prop][value] > b[prop][value]) {
                  return -1;
                }
                if (b[prop][value] > a[prop][value]) {
                  return 1;
                }
                return 0;
              }).map(t =>
                <div key={t[prop][value]} className="generics_selectable_item"
                  onClick={(e) => {
                    if (currentState.rightSelection.indexOf(t) > -1) {
                      e.currentTarget.classList.remove("selected");
                      currentState.rightSelection.splice(currentState.rightSelection.indexOf(t), 1);
                    } else {
                      e.currentTarget.classList.add("selected");
                      currentState.rightSelection.push(t);
                    }
                    this.setState({ form: this.state.form });
                  }}
                  onDoubleClick={() => {
                    if (currentState.rightSelection.indexOf(t) > -1)
                      currentState.rightSelection.splice(currentState.rightSelection.indexOf(t), 1);
                    currentState.targetField.splice(currentState.targetField.indexOf(t), 1);
                    this.setState({ form: this.state.form });
                  }}>{t[prop][value]}</div>)
            }
          </div>
        </div>
      </div >
    </Form.Group >;
  }

  renderCampaignSelector() {
    if (!Array.isArray(this.state.form.programRuleCampaignCode))
      this.state.form.programRuleCampaignCode = (this.state.selectedRule != null) ? JSON.parse(JSON.stringify(this.state.selectedRule.programRuleCampaignCode)) : [];

    if (!Array.isArray(this.state.form.programRuleCampaignCode))
      this.state.form.programRuleCampaignCode = [];

    return <div>
      {
        this.state.form.programRuleCampaignCode == null || this.state.form.programRuleCampaignCode.length == 0 ?
          <div className="generic_empty">{Labels.GetLabel("campaign.nocode")}</div> :
          <Form.Group >
            <div style={{ flexDirection: "row", display: "flex" }}>
              <div style={{ flex: 2, overflow: "hidden" }}>
                <Form.Label className="form-label">{Labels.GetLabel("campaign.code")}</Form.Label>
              </div>
              <div style={{ flex: 4, overflow: "hidden" }}>
                <Form.Label className="form-label">{Labels.GetLabel("campaign.calculation")}</Form.Label>
              </div>
              <div style={{ width: 50, marginLeft: 10 }}>
              </div>
            </div>
            <div>
              {
                this.state.form.programRuleCampaignCode.map(t => {
                  return <div className="inline_container">
                    <div style={{ flex: 2, marginBottom: -20 }}>
                      <MaskedInput type="text"
                        value={t.code}
                        notnull={true} onValid={(value) => { t.code = value }}
                        onInvalid={(value) => t.code = null}
                        placeholder={Labels.GetLabel("generic.value")} />
                    </div>
                    <div style={{ flex: 4, marginBottom: -20 }}>
                      <MaskedInput type="select"
                        value={t.countAll}
                        notnull={true} onValid={(value) => { t.countAll = JSON.parse(value[0]); }}
                        onInvalid={(value) => this.updateForm("countAll", null)} parser={t => Labels.GetLabel("campaign.campaing_type_" + t)} name="keyConstant,keyConstant"
                        data={["true", "false"]} placeholder={Labels.GetLabel("program.type")} />
                    </div>
                    <div className="inline_button" onClick={() => {
                      this.state.form.programRuleCampaignCode.splice(this.state.form.programRuleCampaignCode.indexOf(t), 1);
                      this.setState({ form: this.state.form });
                    }}>
                      <FontAwesomeIcon icon="trash" />
                    </div>
                  </div>;
                })
              }
            </div>
          </Form.Group >
      }
      <br />
      <div>
        <Button variant="success" style={{}} onClick={() => {
          this.state.form.programRuleCampaignCode.push({
            code: null,
            countAll: null
          });
          this.setState({ form: this.state.form });
        }}>
          {Labels.GetLabel("campaign.newcode")}
        </Button>
      </div>
    </div >
  }

  renderBonusSelector() {
    if (!Array.isArray(this.state.form.programRuleBonus))
      this.state.form.programRuleBonus = (this.state.selectedRule != null) ? JSON.parse(JSON.stringify(this.state.selectedRule.programRuleBonus)) : [];

    if (!Array.isArray(this.state.form.programRuleBonus))
      this.state.form.programRuleBonus = [];

    return <div>
      {
        this.state.form.programRuleBonus == null || this.state.form.programRuleBonus.length == 0 ?
          <div className="generic_empty">{Labels.GetLabel("program.norewards")}</div> :
          <Form.Group >
            <div style={{ flexDirection: "row", display: "flex" }}>
              <div style={{ flex: 2, overflow: "hidden" }}>
                <Form.Label className="form-label">{Labels.GetLabel("program.type")}</Form.Label>
              </div>
              <div style={{ flex: 2, overflow: "hidden" }}>
                <Form.Label className="form-label">{Labels.GetLabel("program.goalpercentage")}</Form.Label>
              </div>
              <div style={{ flex: 2, overflow: "hidden" }}>
                <Form.Label className="form-label">{Labels.GetLabel("program.prize")}</Form.Label>
              </div>
              <div style={{ width: 50, marginLeft: 10 }}>
              </div>
            </div>
            <div>
              {
                this.state.form.programRuleBonus.map(t => {
                  return <div className="inline_container">
                    <div style={{ flex: 2, marginBottom: -20 }}>
                      <MaskedInput type="select"
                        value={t.isPoints}
                        notnull={true} onValid={(value) => { t.isPoints = JSON.parse(value[0]); }}
                        onInvalid={(value) => this.updateForm("qualitativeAwardType", null)} parser={t => Labels.GetLabel("program.type_" + t)} name="keyConstant,keyConstant"
                        data={["true", "false"]} placeholder={Labels.GetLabel("program.type")} />
                    </div>
                    <div style={{ flex: 2, marginBottom: -20 }}>
                      <MaskedInput type="decimal"
                        value={t.percentageMaximum}
                        notnull={true} onValid={(value) => t.percentageMaximum = Parsers.normalizeNumber(value)}
                        onInvalid={(value) => t.percentageMaximum = null}
                        placeholder={Labels.GetLabel("program.maxvalue")} />
                    </div>
                    <div style={{ flex: 2, marginBottom: -20 }}>
                      <MaskedInput type="decimal"
                        value={t.multiplierPointsValue}
                        notnull={true} onValid={(value) => t.multiplierPointsValue = Parsers.normalizeNumber(value)}
                        onInvalid={(value) => t.multiplierPointsValue = null}
                        placeholder={Labels.GetLabel("generic.value")} />
                    </div>
                    <div className="inline_button" onClick={() => {
                      this.state.form.programRuleBonus.splice(this.state.form.programRuleBonus.indexOf(t), 1);
                      this.setState({ form: this.state.form });
                    }}>
                      <FontAwesomeIcon icon="trash" />
                    </div>
                  </div>;
                })
              }
            </div>
          </Form.Group >
      }
      <br />
      <div>
        <Button variant="success" style={{}} onClick={() => {
          this.state.form.programRuleBonus.push({
            isPoints: null,
            percentageMaximum: null,
            multiplierPointsValue: null
          });
          this.setState({ form: this.state.form });
        }}>
          {Labels.GetLabel("program.newreward")}
        </Button>
      </div>
    </div >
  }

  renderQaward() {
    return <div style={{ padding: 20, border: "1px solid rgb(200,200,200)", borderRadius: 10, marginBottom: 10, marginTop: 10 }}>
      <div style={{ fontWeight: "bold" }} >{Labels.GetLabel("program.paymenttype")}</div>
      {this.state.data.program.programPaymentType != null ?
        Labels.GetLabel("program_payment_type." + this.state.data.program.programPaymentType.keyConstant) :
        Labels.GetLabel("generic.notinformed")}
      <br />
      <br />
      <div style={{ fontWeight: "bold" }} >{Labels.GetLabel("program.qatype")}</div>
      {this.state.data.program.qualitativeAwardType != null ?
        <div>
          {Labels.GetLabel("qualitative_award_type." + this.state.data.program.qualitativeAwardType.keyConstant)}
          <br />
          <br />
          <div style={{ fontWeight: "bold" }} >{Labels.GetLabel("program.goalmulti")}</div>
          {this.state.data.program.qualitativeAwardMultiplier != null ?
            Labels.GetLabel("qualitative_award_type." + this.state.data.program.qualitativeAwardType.keyConstant) + " x " + Parsers.parseMoney(this.state.data.program.qualitativeAwardMultiplier) + " = " + Labels.GetLabel("program.qualitativeaward") + " (R$)" :
            Labels.GetLabel("generic.notinformed")}
        </div> :
        Labels.GetLabel("generic.notinformed")}
    </div>;
  }

  downloadReport(target, data) {
    var f = "program_" + this.data.id + "_" + target + (typeof data === "string" ? "_" + data : "") + ".xlsx";
    this.setState({ isModalVisible: "downloading", modalInitializing: true });
    Connection.Secure(Connection.service + (
        target == "status" ? 'Report/Program/' + this.data.id + "/" + f :
          target == "results" ? "Report/Calculation/" + this.data.id + "/" + f :
            target == "customers" ? "Report/Customer/" + this.data.id + "/" + f :
              target == "franchisee" ? 'Report/Customer/' + this.data.id + "/" + data + "/true/" + f :
                target == "franchisee_user" ? 'Report/Customer/' + this.data.id + "/" + data + "/" + f
                  : ""))
      .then(res => res.blob())
      .then(blob => {
        this.setState({ isModalVisible: null });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = f;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again
      });
  }

  renderRule(target) {
    return <div style={{ padding: 20, border: "1px solid rgb(200,200,200)", borderRadius: 10, marginBottom: 10, marginTop: 10 }}>
      <div className="rule_btn" onClick={() => Parsers.parsePermission2(["PROGRAM_EDIT"]) ? this.openModal(target == this.state.data.primaryRule ? "mainrule" : "rule", { selectedRule: target }) : null}>{target.label}</div>
      <div style={{display: "flex", flexDirection: "column"}}>
        {
          target.programRuleBonus != null && target.programRuleBonus.length > 0 ?
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20}}>
              <div style={{ fontWeight: "bold" }} >{Labels.GetLabel("program.prize")}</div>
              {
                ((t) => {
                  var r = t.filter(f => { return f.isPoints == true }).sort((a, b) => {
                    if (a.percentageMaximum < b.percentageMaximum) {
                      return -1;
                    }
                    if (a.percentageMaximum > b.percentageMaximum) {
                      return 1;
                    }
                    return 0;
                  });
                  if (r.length == 0) return null;
                  else return <div style={{ marginBottom: 10 }}>
                    {Labels.GetLabel("program.type_true")}:&nbsp;
                {r.map(l => <div>{Labels.GetLabel('program.rangestart') + Parsers.parseNumber(r.indexOf(l) == 0 ? "0" : r[r.indexOf(l) - 1].percentageMaximum) + "%" + Labels.GetLabel('program.range') + " "}{Parsers.parseNumber(l.percentageMaximum)}% {Labels.GetLabel("program.fromgoal")} = {Parsers.parseNumber(l.multiplierPointsValue)}{Labels.GetLabel("program.mainprizetype_" + target.programRulePrizeType.keyConstant)}</div>)}
                  </div>;
                })(target.programRuleBonus)
              }
              {
                ((t) => {
                  var r = t.filter(f => { return f.isPoints != true }).sort((a, b) => {
                    if (a.percentageMaximum < b.percentageMaximum) {
                      return -1;
                    }
                    if (a.percentageMaximum > b.percentageMaximum) {
                      return 1;
                    }
                    return 0;
                  });
                  if (r.length == 0) return null;
                  else return <div  >
                    {Labels.GetLabel("program.type_false")}:&nbsp;
                {r.map(l => <div>{Labels.GetLabel('program.rangestart') + Parsers.parseNumber(r.indexOf(l) == 0 ? 0 : r[r.indexOf(l) - 1].percentageMaximum) + "%" + Labels.GetLabel('program.range') + " "} {Parsers.parseNumber(l.percentageMaximum)}% {Labels.GetLabel("program.fromgoal")} = {Parsers.parseNumber(l.multiplierPointsValue)}{Labels.GetLabel("program.mainprizetype_" + target.programRulePrizeType.keyConstant)}</div>)}
                  </div>;
                })(target.programRuleBonus)
              }
            </div>
            : null
        }
        {
          target.devolutionUnitType != null ?
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program.devolutionshow")}</div>
              {Labels.GetLabel("UNIT_TYPE." + target.devolutionUnitType.keyConstant)}:&nbsp;
              {
                target.devolutionMaximumValue + Labels.GetLabel("UNIT_TYPE_UNIT." + target.devolutionUnitType.keyConstant)
              }
            </div>
            : null
        }
        {
          target.billingMinimumUnitType != null ?
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program.billingshow")}</div>
              {Labels.GetLabel("UNIT_TYPE." + target.billingMinimumUnitType.keyConstant)}:&nbsp;
              {
                target.billingMinimumValue + Labels.GetLabel("UNIT_TYPE_UNIT." + target.billingMinimumUnitType.keyConstant)
              }
            </div>
            : null
        }
        {
          target.productRelationship != null ?
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program.productspart")}</div>
              <div style={{ fontStyle: "italic", marginBottom: 5 }}>{Labels.GetLabel("PRODUCT_RELATIONSHIP." + target.productRelationship.keyConstant)}</div>
              {
                target.productRelationship.keyConstant == 1 || !Array.isArray(target.programRuleProduct) || target.programRuleProduct.length == 0 ? null :
                  target.programRuleProduct.map(t => <span style={{ borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{t.product.label}</span>)
              }
            </div>
            : null
        }

        {
          !Array.isArray(target.programRuleAttribute) || target.programRuleAttribute.length == 0 ? null :
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <b>{Labels.GetLabel("menu.attributes")}</b>
              <div>{target.programRuleAttribute.map(t => <span style={{ borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{" " + t.productGroupAttribute.label}</span>)}</div>
            </div>
        }
        {/* Array do actionPlan */}
        {
          !Array.isArray(target.programRuleActionPlan) || target.programRuleActionPlan.length == 0 ? null :
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <b>{Labels.GetLabel("menu.actionplans")}</b>
              <div>{target.programRuleActionPlan.map(t => <span style={{ display: "flex", flexDirection: "column", borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{" " + t.productGroupActionPlan.label}</span>)}</div>
            </div>
        }
        {
          !Array.isArray(target.programRuleCampaign) || target.programRuleCampaign.length == 0 ? null :
            <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
              <b>{Labels.GetLabel("program.campaign")}</b>
              <div>{target.programRuleCampaign.map(t => <span style={{ borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{" " + t.productCampaing.label}</span>)}</div>
            </div>
        }
        {
          target.programRuleCampaignCode != null && Array.isArray(target.programRuleCampaignCode) && target.programRuleCampaignCode.length > 0 ?
            ((codes) => {
              var exc = codes.filter(t => t.countAll == true), inc = codes.filter(t => t.countAll == false);
              return <div style={{ margin: 10, float: "left", borderLeft: "1px solid rgb(240,240,240)", padding: 20 }}>
                <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("campaign.codes")}</div>
                {
                  exc.length == 0 ? null :
                    <div>
                      <div style={{ fontStyle: "italic", marginBottom: 5 }}>{Labels.GetLabel("campaign.excluded")}</div>
                      {exc.map(t => <span style={{ borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{t.code}</span>)}
                    </div>
                }
                {
                  inc.length == 0 ? null :
                    <div>
                      <div style={{ fontStyle: "italic", marginBottom: 5 }}>{Labels.GetLabel("campaign.included")}</div>
                      {inc.map(t => <span style={{ borderLeft: "1px solid rgb(200,200,200)", marginRight: 10, paddingLeft: 5 }}>{t.code}</span>)}
                    </div>
                }
              </div>;
            })(target.programRuleCampaignCode)
            : null
        }
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  }

  render() {
    return (
      <Container context={this.constructor}>

        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {this.state.data.program.brand.label + " - " + this.state.data.program.label}</span>
                    {/* <div>{Labels.GetLabel(this.state.data.program.fkClientType == null ? "generic.all" : 'CLIENT_TYPE.' + this.state.data.program.fkClientType)}</div> */}
                    <div>{Labels.GetLabel("program.hierarchy") + ": " +Labels.GetLabel("program.hierarchy_" + (this.state.data.program.hierarchy == true))}</div></div>

                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(this.state.status.programStatus.keyConstant) }}>
                    <div className="generics_status_bar_title">
                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(this.state.status.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />{Labels.GetLabel("STATUS_PROGRAM_3." + this.state.status.programStatus.keyConstant)}
                    </div>
                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.status.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(this.state.status.datetimeRegister)})</div>
                    <div className="generics_status_bar_desc">{Labels.GetLabel("PROGRAM_STATUS_PROGRAM_DESC." + this.state.status.programStatus.keyConstant)}</div>
                    {

                      this.state.status.programStatus.keyConstant >= 6 || !Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null :

                        <div style={{ textAlign: "right", marginTop: 20 }}>
                          <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus")}>
                            {Labels.GetLabel("PROGRAM_STATUS_PROGRAM_ACTION." + this.state.status.programStatus.keyConstant)}
                          </Button>
                        </div>
                    }

                  </div>
                  <div style={{ padding: 20 }}>
                    {/* <div className="generic_section_header">{Labels.GetLabel('program.programgoal')}</div>
                    {
                      this.renderGoals()
                    }
                    <br />
                    <br /> */}

                    <Tabs defaultActiveKey="resume" id="uncontrolled-tab-example" onSelect={t => this.onTabChange(t)}>
                      {!Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null :
                        <Tab eventKey="resume" title={Labels.GetLabel("program.programrules")}>
                          {this.state.data.primaryRule != null ?
                            this.renderRule(this.state.data.primaryRule) :
                            <div className="generics_missing_info">
                              <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel('program_state.norules')}</div>
                              <div>{Labels.GetLabel('program_state.norulesdesc')}</div>
                              <div style={{ textAlign: "right", marginTop: 20 }}>
                                {!Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null :
                                  <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("mainrule")}>
                                    {Labels.GetLabel("program.newrule")}
                                  </Button>}
                              </div>
                            </div>
                          }

                          {
                            this.state.data.secondaryRules != null && this.state.data.secondaryRules.length > 0 ? this.state.data.secondaryRules.map(t => this.renderRule(t)) : null
                          }
                          <br />
                        </Tab>
                      }
                      <Tab eventKey="qa" title={Labels.GetLabel("program.qualitativeaward")}>
                        {this.state.data.program.qualitativeAwardMultiplier == null ||
                          this.state.data.program.qualitativeAwardMultiplier == 0 ||
                          this.state.data.program.qualitativeAwardType == null ||
                          this.state.data.program.programPaymentType == null
                          ?
                          <div className="generics_missing_info">
                            <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel('program_state.noqaward')}</div>
                            <div>{Labels.GetLabel('program_state.noqawarddesc')}</div>
                            <div style={{ textAlign: "right", marginTop: 20 }}>
                              {!Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null : <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("qaward")}>
                                {Labels.GetLabel("program.qualitativeaward")}
                              </Button>}
                            </div>
                          </div> :

                          this.renderQaward()
                        }
                        </Tab>
                        <br />
                        <Tab eventKey="actionPlan" title={Labels.GetLabel("generic.actionPlans")}>
                          <div>
                            {this.state.data.primaryRule?.programRuleActionPlan == null || this.state.data.primaryRule?.programRuleActionPlan == 0 ?
                              <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                              <div style={{ padding: 20, border: "1px solid rgb(200,200,200)", borderRadius: 10, marginBottom: 10, marginTop: 10 }}>
                                {this.state.data.primaryRule.programRuleActionPlan.map(item =>
                                  <div className="generics_listing_item" >
                                    <FontAwesomeIcon icon="cube" className="generics_listing_item_icon" />
                                    <div className="generics_listing_content" >
                                      <div className="generics_listing_item_title" >{Parsers.parseUpperCase(item.productGroupActionPlan.label)}</div>
                                      <div className="generics_listing_item_description" >{item.productGroupActionPlan.description}</div>
                                    </div>
                                  </div>
                                )}
                              </div>}
                          </div>
                        </Tab>
                      <br />
                      <Tab eventKey="home" title={Labels.GetLabel("program.chronogram")}>
                        {
                          this.state.data.program.dtProgramStart == null || this.state.data.program.dtProgramEnd == null ?
                            <div className="generics_missing_info">
                              <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel('program_state.nochronogram')}</div>
                              <div>{Labels.GetLabel('program_state.nochronogramdesc')}</div>
                              {!Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null : <div style={{ textAlign: "right", marginTop: 20 }}>
                                <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("date")}>
                                  {Labels.GetLabel("program.chronogram")}
                                </Button>
                              </div>}
                            </div> :
                            this.renderChronogram()
                        }
                      </Tab>
                      <Tab eventKey="files" title={Labels.GetLabel("generic.files")}>
                        <div>
                          {this.state.data.program.storageProgramElement == null || this.state.data.program.storageProgramElement.length == 0 ?
                            <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                            <div style={{ padding: 20, border: "1px solid rgb(200,200,200)", borderRadius: 10, marginBottom: 10, marginTop: 10 }}>
                              {this.state.data.program.storageProgramElement.map(item => <a href={Connection.service + "Program/" + this.data.id + "/File/" + item.storageManager.keyConstant + "/" + item.storageManager.filename} className="generics_listing_item" target="_blank" >
                                <FontAwesomeIcon icon="file" className="generics_listing_item_icon" />
                                <div className="generics_listing_content" >
                                  <div className="generics_listing_item_title" >{item.storageManager.value}</div>
                                  <div className="generics_listing_item_description" >{item.observation}</div>
                                  <div style={{ textAlign: "right" }}>{item.storageManager.filename}</div>
                                </div>
                                {
                                  !Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null :
                                    <div className="generics_listing_item_action" onClick={(e) => { this.setState({ isModalVisible: "delete", selectedItem: item }); return GenericHelper.cancelBubble(e); }}><FontAwesomeIcon icon="times" /></div>
                                }
                              </a>)}
                            </div>}
                        </div>
                      </Tab>
                    </Tabs>
                    <br />
                    <br />
                  </div>
                </div>
                <div className="generics_actionbar">
                  {!Parsers.parsePermission2(["PROGRAM_EDIT"]) ? null : <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("program.edit")}
                    onSelect={(t) => this.openModal(t)}
                  >
                    <Dropdown.Item eventKey="info" >{Labels.GetLabel("program.info")}</Dropdown.Item>
                    <Dropdown.Item eventKey="date" >{Labels.GetLabel("program.chronogram")}</Dropdown.Item>
                    {/* <Dropdown.Item eventKey="goal">{Labels.GetLabel("program.programgoal")}</Dropdown.Item> */}
                    {
                      this.state.data.primaryRule == null ?
                        <Dropdown.Item eventKey="mainrule">{Labels.GetLabel("program.newprogramrules")}</Dropdown.Item> :

                        <Dropdown.Item eventKey="mainrule" >{Labels.GetLabel("program.programrule")}</Dropdown.Item>
                    }
                    {
                      this.state.data.primaryRule == null ?
                        null :

                        <Dropdown.Item eventKey="rule">{Labels.GetLabel("program.newprogramrulessec")}</Dropdown.Item>
                    }
                    <Dropdown.Item eventKey="qaward">{Labels.GetLabel("program.qualitativeaward")}</Dropdown.Item>
                    <Dropdown.Item eventKey="file">{Labels.GetLabel("program.newfile")}</Dropdown.Item>
                    <Dropdown.Item eventKey="select">{Labels.GetLabel("program.newgoal")}</Dropdown.Item>
                    <Dropdown.Item eventKey="insertresult">{Labels.GetLabel("program.insertresult")}</Dropdown.Item>
                    {
                      this.state.status.programStatus.keyConstant < 3 ?
                        <Dropdown.Item eventKey="deleteprogram">{Labels.GetLabel("program.deleteprogram")}</Dropdown.Item>
                        : null
                    }
                    
                  </DropdownButton>}
                  <div>
                    <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("history")}>
                      {Labels.GetLabel("generic.history")}
                    </Button>

                    <DropdownButton
                      as={ButtonGroup}
                      key="up"
                      drop="up"
                      variant="primary" style={{ marginRight: 10 }}
                      onSelect={(t) => {
                        switch (t) {
                          case "statement":
                          case "status":
                          case "customers":
                          case "results":
                            this.downloadReport(t);
                            break;
                          case "franchisee_user":
                            this.downloadReport(t, global.user.keyRegister);
                            break;
                          case "franchisee":
                            this.openModal(t);
                            break;
                        }
                      }}
                    >
                      {
                        !Parsers.parsePermission(["FRANCHISEE_ADMIN", "FRANCHISEE_USER"]) ? null :
                          <Dropdown.Item eventKey="franchisee_user" >{Labels.GetLabel("login.user1")}</Dropdown.Item>
                      }
                      {!Parsers.parsePermission2(["PROGRAM_REPORT_STATUS"]) ? null :
                        <Dropdown.Item eventKey="status" >{Labels.GetLabel("program.info")}</Dropdown.Item>
                      }
                      {!Parsers.parsePermission2(["PROGRAM_REPORT_CUSTOMERS"]) ? null :
                        <Dropdown.Item eventKey="customers" >{Labels.GetLabel("login.user1")}</Dropdown.Item>
                      }
                      {!Parsers.parsePermission2(["PROGRAM_REPORT_RESULTS"]) ? null :
                        <Dropdown.Item eventKey="results" >{Labels.GetLabel("generic.results")}</Dropdown.Item>
                      }
                      {!Parsers.parsePermission2(["PROGRAM_REPORT_FRANCHISEE"]) ? null :
                        <Dropdown.Item eventKey="franchisee" >{Labels.GetLabel("program.reportfranchisee")}</Dropdown.Item>
                      }
                    </DropdownButton>
                  </div>
                  <div style={{ flex: 1 }}></div>
                  <Button variant="primary" style={{}} onClick={() => this.props.history.push('/Program/Detail/' + this.data.id + '/Goals')}>
                    {Labels.GetLabel("menu.programgoals")}
                  </Button>
                  <div style={{ clear: "both" }}></div>
                </div>
                <Modal
                  className={this.state.modalLoading == true ? "modal-loading" : ""}
                  onHide={() => { }} show={this.state.isModalVisible != null}
                // onHide={handleClose}
                >
                  <div>
                    {
                      this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                        <div>
                          {Labels.GetLabel("adminstategroup.saving")}
                        </div>
                        : this.state.isModalVisible == "insertresult" ?
                          <div>
                            <div>
                              <Modal.Header>
                                <Modal.Title>{Labels.GetLabel("program.insertresult")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form.Label>{Labels.GetLabel("program_refund.worksheet")}</Form.Label>
                                <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="primary" disabled={this.state.file == null} onClick={() => this.addNewFileResult()}>
                                  {Labels.GetLabel("adminstategroup.savebtn")}
                                  </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>
                          </div> 
                        : this.state.isModalVisible == "confirmresult" ?
                        <div>
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("program.insertresult")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <Form.Label>{Labels.GetLabel("generic.sendactivate")}</Form.Label>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("userhistory.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                        </div> 
                        : this.state.isModalVisible == "confirmnotresult" ?
                        <div>
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("program.insertresult")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <Form.Label>{Labels.GetLabel("generic.sendnotactivate")}</Form.Label>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("userhistory.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                        </div>   
                        : this.state.isModalVisible == "history" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("generic.history")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              {
                                this.state.data.program.programStatusElement.map(t =>
                                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(t.programStatus.keyConstant) }}>
                                    <div className="generics_status_bar_title">
                                      <FontAwesomeIcon
                                        icon={Parsers.GetStatusIcon(t.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />
                                        {Labels.GetLabel("STATUS_PROGRAM_3." + t.programStatus.keyConstant)}
                                    </div>
                                    <div
                                      className="generic_status_author">
                                        {Parsers.parseUpperCase(GenericHelper.parseInformation(t.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(t.datetimeRegister)})
                                    </div>
                                  </div>)
                              }
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                          :
                          this.state.isModalVisible == "mainrule" ||
                            this.state.isModalVisible == "rule" ?
                            <div>
                              <Modal.Header>
                                <Modal.Title>{this.state.isModalVisible == "mainrule" ? Labels.GetLabel("program.programrule") : Labels.GetLabel("program.programrulessec")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div>
                                  <MaskedInput type="text" label={Labels.GetLabel("generic.name")}
                                    value={this.state.selectedRule != null ? this.state.selectedRule.label : null}
                                    notnull={true} onValid={(value) => this.updateForm("label", value)}
                                    onInvalid={(value) => this.updateForm("label", null)} name="keyConstant,keyConstant" />
                                  <div style={{ position: "relative" }}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="select" label={Labels.GetLabel("program.billing")}
                                          value={this.state.selectedRule != null && this.state.selectedRule.billingMinimumUnitType != null ? this.state.selectedRule.billingMinimumUnitType.keyConstant : null}
                                          onValid={(value) => this.updateForm("billingMinimumUnitType", value == null ? null : { keyConstant: parseInt(value[0]) })}
                                          onInvalid={(value) => this.updateForm("billingMinimumUnitType", null)} parser={t => Labels.GetLabel("UNIT_TYPE." + t)} name="keyConstant,keyConstant"
                                          data={this.state.loadedRule.unit} placeholder={Labels.GetLabel("generic.notinformed")} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>{
                                        this.state.form.billingMinimumUnitType != null ?
                                          <MaskedInput type="decimal" label={Labels.GetLabel("program.minvalue")}
                                            value={this.state.selectedRule != null ? this.state.selectedRule.billingMinimumValue : null}
                                            notnull={true} onValid={(value) => this.updateForm("billingMinimumValue", Parsers.normalizeNumber(value))}
                                            onInvalid={(value) => this.updateForm("billingMinimumValue", null)} name="keyConstant,keyConstant" />
                                          : null
                                      } </div>
                                    </div>
                                  </div>
                                  <div style={{ position: "relative" }}>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="select" label={Labels.GetLabel("program.devolution")}
                                          value={this.state.selectedRule != null && this.state.selectedRule.devolutionUnitType != null ? this.state.selectedRule.devolutionUnitType.keyConstant : null}
                                          onValid={(value) => this.updateForm("devolutionUnitType", value == null ? null : { keyConstant: parseInt(value[0]) })}
                                          onInvalid={(value) => this.updateForm("devolutionUnitType", null)} parser={t => Labels.GetLabel("UNIT_TYPE." + t)} name="keyConstant,keyConstant"
                                          data={this.state.loadedRule.unit} placeholder={Labels.GetLabel("generic.notinformed")} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>{
                                        this.state.form.devolutionUnitType != null ?
                                          <MaskedInput type="decimal" label={Labels.GetLabel("program.maxvalue")}
                                            value={this.state.selectedRule != null ? this.state.selectedRule.devolutionMaximumValue : null}
                                            notnull={true} onValid={(value) => this.updateForm("devolutionMaximumValue", Parsers.normalizeNumber(value))}
                                            onInvalid={(value) => this.updateForm("devolutionMaximumValue", null)} name="keyConstant,keyConstant" />
                                          : null
                                      }
                                      </div>
                                    </div>
                                  </div>
                                  <br />
                                  <div className="generic_section_header">{Labels.GetLabel('program.reward')}</div>
                                  <MaskedInput type="select" label={Labels.GetLabel("program.mainprizetype")}
                                    value={this.state.selectedRule != null && this.state.selectedRule.programRulePrizeType != null ? this.state.selectedRule.programRulePrizeType.keyConstant : null}
                                    notnull={true} onValid={(value) => this.updateForm("programRulePrizeType", { keyConstant: parseInt(value[0]) })}
                                    onInvalid={(value) => this.updateForm("programRulePrizeType", null)} parser={t => Labels.GetLabel("PROGRAM_RULE_PRIZE_TYPE." + t)} name="keyConstant,keyConstant"
                                    data={this.state.loadedRule.programRulePrizeType} placeholder={Labels.GetLabel("generic.select")} />
                                  {this.renderBonusSelector()}
                                  <br />
                                  <br />
                                  {/* {this.renderProductSelector("programRuleCampaign", this.state.loadedRule.campaign, "productCampaing", "label")} */}
                                  <div className="generic_section_header">{Labels.GetLabel('menu.product')}</div>
                                  <Form.Group >
                                    <MaskedInput type="select" label={Labels.GetLabel("program.productrelation")}
                                      value={this.state.selectedRule != null && this.state.selectedRule.productRelationship != null ? this.state.selectedRule.productRelationship.keyConstant : null}
                                      notnull={true} onValid={(value) => this.updateForm("productRelationship", { keyConstant: parseInt(value[0]) })}
                                      onInvalid={(value) => this.updateForm("productRelationship", null)} parser={t => Labels.GetLabel("PRODUCT_RELATIONSHIP." + t)} name="keyConstant,keyConstant"
                                      data={this.state.loadedRule.relationship} placeholder={Labels.GetLabel("generic.select")} />
                                    {this.state.form.productRelationship != null && (this.state.form.productRelationship.keyConstant == 2 || this.state.form.productRelationship.keyConstant == 3) ?

                                      this.renderProductSelector("programRuleProduct", this.state.loadedRule.products, "product", "label")
                                      : null
                                    }
                                  </Form.Group >
                                  <br />
                                  <div className="generic_section_header">{Labels.GetLabel('menu.attributes')}</div>
                                  {this.renderProductSelector("programRuleAttribute", this.state.loadedRule.attribute, "productGroupAttribute", "label")}
                                  <br />
                                  <div className="generic_section_header">{Labels.GetLabel('menu.actionplans')}</div>
                                  {this.renderProductSelector("programRuleActionPlan", this.state.loadedRule.actionPlan, "productGroupActionPlan", "label")}
                                  <br />
                                  <div className="generic_section_header">{Labels.GetLabel('program.campaign')}</div>
                                  {this.renderCampaignSelector()}
                                  <br />
                                  <br />
                                  <br />
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                {this.state.isModalVisible == "rule" && this.state.selectedRule != null ?
                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: "deleterule" })}>
                                    {Labels.GetLabel("program.deleterule")}
                                  </Button>
                                  : null}
                                <div style={{ flex: 1 }}></div>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="success"
                                  disabled={typeof this.state.form.label !== "string" || this.state.form.label.length == 0 ||
                                    typeof this.state.form.productRelationship !== "object" || this.state.form.productRelationship == null ||
                                    typeof this.state.form.programRulePrizeType !== "object" || this.state.form.programRulePrizeType == null
                                  }
                                  onClick={() => this.saveRule(this.state.form)}>
                                  {Labels.GetLabel("adminstategroup.savebtn")}
                                </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>

                            : this.state.isModalVisible == "deleterule" ?
                              <div>
                                <Modal.Header>
                                  <Modal.Title>{Labels.GetLabel("program.deleterule")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  {Labels.GetLabel("program.confirmdelrule")}
                                  <br />
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                  </Button>
                                  <Button variant="primary" onClick={() => this.deleteRule(this.state.selectedRule)}>
                                    {Labels.GetLabel("generic.confirm")}
                                  </Button>
                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                              </div>
                              :
                              this.state.isModalVisible == "info" ?
                                <div>
                                  <Modal.Header>
                                    <Modal.Title>{Labels.GetLabel("program.info")}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <MaskedInput type="text" label={Labels.GetLabel("program.name")}
                                      value={this.state.data.program.label != null ? this.state.data.program.label : null}
                                      notnull={true} onValid={(value) => this.updateForm("label", value)}
                                      onInvalid={(value) => this.updateForm("label", null)} name="keyConstant,keyConstant" />
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                      {Labels.GetLabel("adminstategroup.closebtn")}
                                    </Button>
                                    <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.updateValues()}>
                                      {Labels.GetLabel("adminstategroup.savebtn")}
                                    </Button>
                                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                </div>
                                :
                                this.state.isModalVisible == "qaward" ?
                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.qualitativeaward")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <MaskedInput type="select" label={Labels.GetLabel("program.paymenttype")} notnull={true} onValid={(value) => this.updateForm("programPaymentType", { keyConstant: parseInt(value[0]) })}
                                        onInvalid={(value) => this.updateForm("programPaymentType", null)}
                                        value={this.state.data.program.programPaymentType != null ? this.state.data.program.programPaymentType.keyConstant : null}
                                        parser={t => Labels.GetLabel("program_payment_type." + t)} name="keyConstant,keyConstant" data={this.state.loadedQa.payment} placeholder={Labels.GetLabel("generic.select")} />
                                      <div style={{ display: "flex" }}>
                                        <div style={{ flex: 1 }}>
                                          <MaskedInput type="select" label={Labels.GetLabel("program.qatype")}
                                            value={this.state.data.program.qualitativeAwardType != null ? this.state.data.program.qualitativeAwardType.keyConstant : null}
                                            notnull={true} onValid={(value) => this.updateForm("qualitativeAwardType", { keyConstant: parseInt(value[0]) })}
                                            onInvalid={(value) => this.updateForm("qualitativeAwardType", null)} parser={t => Labels.GetLabel("qualitative_award_type." + t)} name="keyConstant,keyConstant" data={this.state.loadedQa.qatype} placeholder={Labels.GetLabel("generic.select")} />
                                        </div>
                                        <div style={{ flex: 1, marginLeft: 10 }}>
                                          <MaskedInput type="decimal" label={Labels.GetLabel("program.goalmulti")}
                                            value={this.state.data.program.qualitativeAwardMultiplier != null ? this.state.data.program.qualitativeAwardMultiplier : null}
                                            notnull={true} onValid={(value) => this.updateForm("qualitativeAwardMultiplier", Parsers.normalizeNumber(value))}
                                            onInvalid={(value) => this.updateForm("qualitativeAwardMultiplier", null)} name="keyConstant,keyConstant" />
                                        </div>
                                      </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.updateValues()}>
                                        {Labels.GetLabel("adminstategroup.savebtn")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                                  :
                                  this.state.isModalVisible == "goal" ?
                                    <div>
                                      <Modal.Header>
                                        <Modal.Title>{Labels.GetLabel("program.programgoal")}</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <div style={{ display: "flex" }}>
                                          <div style={{ flex: 1 }}>
                                            <MaskedInput type="select" label={Labels.GetLabel("program.billing")} notnull={true}
                                              value={this.state.data.program.programBillingType != null ? this.state.data.program.programBillingType.keyConstant : null}
                                              onValid={(value) => this.updateForm("programBillingType", { keyConstant: parseInt(value[0]) })}
                                              onInvalid={(value) => this.updateForm("programBillingType", null)} parser={t => Labels.GetLabel("program_billing_type." + t)} name="keyConstant,keyConstant" data={this.state.loadedGoal.billing} placeholder={Labels.GetLabel("generic.select")} />
                                          </div>
                                          <div style={{ flex: 1, marginLeft: 10 }}>
                                            <MaskedInput type="select" label={Labels.GetLabel("program.period")} notnull={true}
                                              value={this.state.data.program.programPeriodType != null ? this.state.data.program.programPeriodType.keyConstant : null}
                                              onValid={(value) => this.updateForm("programPeriodType", { keyConstant: parseInt(value[0]) })}
                                              onInvalid={(value) => this.updateForm("programPeriodType", null)} parser={t => Labels.GetLabel("program_period_type." + t)} name="keyConstant,keyConstant" data={this.state.loadedGoal.period} placeholder={Labels.GetLabel("generic.select")} />
                                          </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                          <div style={{ flex: 1 }}>
                                            <MaskedInput type="decimal" icon="percentage" label={Labels.GetLabel("program.percentualgrow")}
                                              value={this.state.data.program.percentageGrowth != null ? this.state.data.program.percentageGrowth : null}
                                              notnull={true} onValid={(value) => this.updateForm("percentageGrowth", Parsers.normalizeNumber(value))}
                                              onInvalid={(value) => this.updateForm("percentageGrowth", null)} name="keyConstant,keyConstant" />
                                          </div>
                                          <div style={{ flex: 1, marginLeft: 10 }}>
                                            <MaskedInput type="decimal" label={Labels.GetLabel("program.minimumbill")} notnull={true}
                                              value={this.state.data.program.minimumBilling != null ? this.state.data.program.minimumBilling : null}
                                              onValid={(value) => this.updateForm("minimumBilling", Parsers.normalizeNumber(value))}
                                              onInvalid={(value) => this.updateForm("minimumBilling", null)} name="keyConstant,keyConstant" />
                                          </div>
                                        </div>
                                        <MaskedInput type="decimal" label={Labels.GetLabel("program.valueperpoint")} notnull={true}
                                          value={this.state.data.program.valuePoint != null ? this.state.data.program.valuePoint : null}
                                          onValid={(value) => this.updateForm("valuePoint", Parsers.normalizeNumber(value))}
                                          onInvalid={(value) => this.updateForm("valuePoint", null)} name="keyConstant,keyConstant" />
                                        <br />
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                          {Labels.GetLabel("adminstategroup.closebtn")}
                                        </Button>
                                        <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.updateValues()}>
                                          {Labels.GetLabel("adminstategroup.savebtn")}
                                        </Button>
                                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                    </div>
                                    :
                                    this.state.isModalVisible == "date" ?

                                      <div>
                                        <Modal.Header>
                                          <Modal.Title>{Labels.GetLabel("program.chronogram")}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <div style={{ display: "flex" }}>
                                            <div>
                                              <div className="item_label2"></div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.program")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.points")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.accept")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.launch")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.qa")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.buy")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.devtotal")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.histbui")}</div>
                                              <div className="item_label">{Labels.GetLabel("program_schedule.histdev")}</div>
                                            </div>
                                            <div style={{ flex: 1, marginLeft: 10 }}>
                                              <div style={{ display: "flex" }}>
                                                <div className="item_label2" style={{ marginRight: 10 }}>{Labels.GetLabel("generic.start")}</div>
                                                <div className="item_label2">{Labels.GetLabel("generic.end")}</div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtProgramStart", this.parseDate(value))}
                                                    value={this.state.form.dtProgramStart}
                                                    onInvalid={(value) => this.updateForm("dtProgramStart", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtProgramEnd", this.parseDate(value))}
                                                    value={this.state.form.dtProgramEnd}
                                                    onInvalid={(value) => this.updateForm("dtProgramEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtValidityPoints", this.parseDate(value))}
                                                    value={this.state.form.dtValidityPoints}
                                                    onInvalid={(value) => this.updateForm("dtValidityPoints", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dateLimitAcceptance", this.parseDate(value))}
                                                    value={this.state.form.dateLimitAcceptance}
                                                    onInvalid={(value) => this.updateForm("dateLimitAcceptance", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dateLimitPromoFunds", this.parseDate(value))}
                                                    value={this.state.form.dateLimitPromoFunds}
                                                    onInvalid={(value) => this.updateForm("dateLimitPromoFunds", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtPromoBudgetPlanEnd", this.parseDate(value))}
                                                    value={this.state.form.dtPromoBudgetPlanEnd}
                                                    onInvalid={(value) => this.updateForm("dtPromoBudgetPlanEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtPurchaseStart", this.parseDate(value))}
                                                    value={this.state.form.dtPurchaseStart}
                                                    onInvalid={(value) => this.updateForm("dtPurchaseStart", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtPurchaseEnd", this.parseDate(value))}
                                                    value={this.state.form.dtPurchaseEnd}
                                                    onInvalid={(value) => this.updateForm("dtPurchaseEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtTotalReturnStart", this.parseDate(value))}
                                                    value={this.state.form.dtTotalReturnStart}
                                                    onInvalid={(value) => this.updateForm("dtTotalReturnStart", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtTotalReturnEnd", this.parseDate(value))}
                                                    value={this.state.form.dtTotalReturnEnd}
                                                    onInvalid={(value) => this.updateForm("dtTotalReturnEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtPurchaseHistoryStart", this.parseDate(value))}
                                                    value={this.state.form.dtPurchaseHistoryStart}
                                                    onInvalid={(value) => this.updateForm("dtPurchaseHistoryStart", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtPurchaseHistoryEnd", this.parseDate(value))}
                                                    value={this.state.form.dtPurchaseHistoryEnd}
                                                    onInvalid={(value) => this.updateForm("dtPurchaseHistoryEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                              <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1, marginRight: 10 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtHistoryRetPurchaseStart", this.parseDate(value))}
                                                    value={this.state.form.dtHistoryRetPurchaseStart}
                                                    onInvalid={(value) => this.updateForm("dtHistoryRetPurchaseStart", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                  <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("dtHistoryRetPurchaseEnd", this.parseDate(value))}
                                                    value={this.state.form.dtHistoryRetPurchaseEnd}
                                                    onInvalid={(value) => this.updateForm("dtHistoryRetPurchaseEnd", null)} placeholder={"dd/mm/aaaa"} />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                          <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                            {Labels.GetLabel("adminstategroup.closebtn")}
                                          </Button>
                                          <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.updateValues()}>
                                            {Labels.GetLabel("adminstategroup.savebtn")}
                                          </Button>
                                        </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                      </div>
                                      : this.state.isModalVisible == "select" ?
                                        <div>
                                          <Modal.Header>
                                            <Modal.Title>{Labels.GetLabel("program.newgoal")}</Modal.Title>
                                          </Modal.Header>
                                          <Modal.Body>
                                            {this.state.data.program.fkClientType != null ? null :
                                              <MaskedInput type="select" onValid={(value) => this.setState({ selectedType: Array.isArray(value) ? value[0] : null })}
                                                onInvalid={(value) => this.setState({ selectedType: null })} parser={(t, v) => Labels.GetLabel("CLIENT_TYPE." + v, t)}
                                                name="bunch,label" data={this.state.loadedSelect.types} placeholder={Labels.GetLabel("generic.clienttype")} />
                                            }
                                            <InputGroup className="mb-3">
                                              <DropdownButton
                                                as={InputGroup.Prepend}
                                                variant="outline-secondary"
                                                title={Labels.GetLabel("generic." + this.state.selectionType)}
                                              >
                                                <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("name")}>{Labels.GetLabel("generic.name")}</Dropdown.Item>
                                                <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("docnumb")}>{Labels.GetLabel("generic.docnumb")}</Dropdown.Item>
                                                <Dropdown.Item href="#" onClick={(t) => this.changeDropdown("customercode")}>{Labels.GetLabel("generic.customercode")}</Dropdown.Item>
                                              </DropdownButton>
                                              <FormControl aria-describedby="basic-addon1" value={this.state.filter} onChange={(v) => this.setState({ filter: v.currentTarget.value })} />
                                            </InputGroup>
                                            <div style={{ display: "flex" }}>
                                              <div style={{ width: "30%", marginRight: 10 }}>
                                                <MaskedInput type="select" onValid={(value) => { this.setState({ region: Array.isArray(value) ? value[0] : null }) }}
                                                  onInvalid={(value) => this.setState({ region: null })} name="label,description" data={this.state.loadedSelect.states} placeholder={Labels.GetLabel("generic.state")} />
                                              </div>
                                              <div style={{ flex: 1 }}>
                                                <MaskedInput type="text" onValid={(value) => this.setState({ city: value == null ? null : value.normalize("NFD").replace(/[\u0300-\u036f]/g, "") })}
                                                  onInvalid={(value) => this.setState({ city: null })} placeholder={Labels.GetLabel("generic.city")} />
                                              </div>
                                            </div>
                                            <Button variant="success" block disabled={this.state.modalLoading} onClick={() => this.searchClients()}>
                                              {Labels.GetLabel("clients.pesquisar")}
                                            </Button>
                                            <br />
                                            <div className="generics_panels_header"><FontAwesomeIcon icon="list" /> <span>{Labels.GetLabel("clients.results")} ({Array.isArray(this.state.clientList) ? this.state.clientList.length : 0})</span></div>
                                            {
                                              this.state.costumerLoading ? <div>{Labels.GetLabel("generic.loading")}</div> :
                                                Array.isArray(this.state.clientList) && this.state.clientList.length > 0 ?
                                                  this.state.clientList.map((item) => {
                                                    return <Link onClick={() => this.chooseClient(item)} className="generics_listing_item" >
                                                      <FontAwesomeIcon icon="building" className="generics_listing_item_icon" />
                                                      <div className="generics_listing_content" >
                                                        <div>#{item.customerCode}</div>
                                                        <div className="generics_listing_item_title" >{item.name1 + (item.name2 == null ? "" : item.name2)
                                                          + (item.name3 == null ? "" : item.name3)
                                                          + (item.name4 == null ? "" : item.name4)}</div>
                                                        <div className="generics_listing_item_description" >
                                                          <div style={{ float: "left" }}>{Parsers.parseCPNJ(item.cnpjCode)}</div>
                                                          <div style={{ float: "right", marginLeft: 10 }}>{item.headOfficeAcc != null ? Labels.GetLabel("program.hierarchy_false") + " (#" + item.headOfficeAcc + ")" : Labels.GetLabel("program.hierarchy_true")}</div>
                                                          <div style={{ clear: "both" }}></div>
                                                        </div>
                                                      </div>
                                                    </Link>
                                                  })
                                                  : this.state.data == null ?
                                                    <div className="generic_empty">{Labels.GetLabel('generic.fillParameters')}</div>
                                                    :
                                                    <div className="generic_empty">{Labels.GetLabel('generic.noresult')}</div>
                                            }
                                          </Modal.Body>
                                          <Modal.Footer>
                                            <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                              {Labels.GetLabel("adminstategroup.closebtn")}
                                            </Button>
                                          </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                        </div>
                                        : this.state.isModalVisible == "newgoal" ?
                                          <div>
                                            <Modal.Header>
                                              <Modal.Title>{Labels.GetLabel("menu.programgoal")}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              <div className="generics_listing_item" >
                                                <FontAwesomeIcon icon="building" className="generics_listing_item_icon" />
                                                <div className="generics_listing_content" >
                                                  <div>#{this.state.selectedClient.customerCode}</div>
                                                  <div className="generics_listing_item_title" >{this.state.selectedClient.name1 + (this.state.selectedClient.name2 == null ? "" : this.state.selectedClient.name2)
                                                    + (this.state.selectedClient.name3 == null ? "" : this.state.selectedClient.name3)
                                                    + (this.state.selectedClient.name4 == null ? "" : this.state.selectedClient.name4)}</div>
                                                  <div className="generics_listing_item_description" >
                                                    <div style={{ float: "left" }}>{Parsers.parseCPNJ(this.state.selectedClient.cnpjCode)}</div>
                                                    <div style={{ float: "right", marginLeft: 10 }}>{this.state.selectedClient.headOfficeAcc != null ? Labels.GetLabel("program.hierarchy_false") + " (#" + this.state.selectedClient.headOfficeAcc + ")" : Labels.GetLabel("program.hierarchy_true")}</div>
                                                    <div style={{ clear: "both" }}></div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                <br />
                                                <MaskedInput type="int" notnull={true} label={Labels.GetLabel("menu.programgoal")} onValid={(value) => {
                                                  var g = parseInt(value);
                                                  if (isNaN(g) || g <= 0) {
                                                    this.setState({ goal: null });
                                                    return false;
                                                  }
                                                  this.setState({ goal: g });
                                                }}
                                                  onInvalid={(value) => this.setState({ goal: null })} />
                                                <MaskedInput type="select" label={Labels.GetLabel("adminstategroup.newlabel")} notnull={true}
                                                  onValid={(value) => this.loadFranchisee(parseInt(value[0]))}
                                                  onInvalid={(value) => this.setState({ selectedStateGroup: null, selectedFranchisee: null })}
                                                  name="keyConstant,label" data={this.state.statesgroups} placeholder={Labels.GetLabel("generic.select")} />
                                                {
                                                  this.state.selectedStateGroup == null ? null :
                                                    <div>
                                                      {this.state.loadingFranchisee == null ?
                                                        <div><FontAwesomeIcon spin={true} icon="cog" /> {Labels.GetLabel("generic.loading")}</div>
                                                        :
                                                        <div>
                                                          <MaskedInput type="select" label={Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE")} notnull={true}
                                                            onValid={(value, target) => { var v = this.selectFranchisee(target.getData(), value[0]); this.setState({ selectedFranchisee: v }) }}
                                                            onInvalid={(value) => this.setState({ selectedFranchisee: null })}
                                                            name={(d) => [d.detail.customerCode, d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                              + (d.detail.name3 == null ? "" : d.detail.name3)
                                                              + (d.detail.name4 == null ? "" : d.detail.name4)]
                                                            } parser={(t, v, d) => {
                                                              return d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                                + (d.detail.name3 == null ? "" : d.detail.name3)
                                                                + (d.detail.name4 == null ? "" : d.detail.name4)
                                                            }
                                                            } data={this.state.loadingFranchisee} placeholder={Labels.GetLabel("generic.select")} />

                                                          {this.state.selectedFranchisee != null ?
                                                            <div>
                                                              {this.state.selectedFranchisee.mainCompany.personPermissionGroup.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                                                                this.state.selectedFranchisee.mainCompany.personPermissionGroup.map(item => <div className="generics_listing_item" >
                                                                  <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
                                                                  <div className="generics_listing_content" >
                                                                    <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}{item.mainPerson.brand ? <span>{item.mainPerson.brand.label}</span> : null}</div>
                                                                    <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 9, "valueType", null, "Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 8, "valueType", null, " Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 7, "valueType", null, " ")}</div>
                                                                    <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.mainPerson.personValue, 3, "valueType", null, " Email:"))}
                                                                      <span>{Labels.GetLabel("permission." + item.logicalApGroups.name)}</span></div>
                                                                  </div>
                                                                </div>)}
                                                            </div> : null}
                                                        </div>}
                                                    </div>
                                                }
                                              </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                {Labels.GetLabel("adminstategroup.closebtn")}
                                              </Button>
                                              <Button variant="primary" disabled={this.state.goal == null || this.state.selectedStateGroup == null || this.state.selectedFranchisee == null} onClick={() => this.addGoal()}>
                                                {Labels.GetLabel("adminstategroup.savebtn")}
                                              </Button>
                                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                          </div>
                                          : this.state.isModalVisible == "franchisee" ?
                                            <div>
                                              <Modal.Header>
                                                <Modal.Title>{Labels.GetLabel("menu.programgoal")}</Modal.Title>
                                              </Modal.Header>
                                              <Modal.Body>
                                                <div>
                                                  <br />
                                                  <MaskedInput type="select" label={Labels.GetLabel("adminstategroup.newlabel")} notnull={true}
                                                    onValid={(value) => this.loadFranchisee(parseInt(value[0]))}
                                                    onInvalid={(value) => this.setState({ selectedStateGroup: null, selectedFranchisee: null })}
                                                    name="keyConstant,label" data={this.state.loadedState.stateGroup} placeholder={Labels.GetLabel("generic.select")} />
                                                  {
                                                    this.state.selectedStateGroup == null ? null :
                                                      <div>
                                                        {this.state.loadingFranchisee == null ?
                                                          <div><FontAwesomeIcon spin={true} icon="cog" /> {Labels.GetLabel("generic.loading")}</div>
                                                          :
                                                          <div>
                                                            <MaskedInput type="select" label={Labels.GetLabel("adminstategroupdetail.EMPLOYEE_FRANCHISEE")} notnull={true}
                                                              onValid={(value, target) => { var v = this.selectFranchisee(target.getData(), value[0]); this.setState({ selectedFranchisee: v }) }}
                                                              onInvalid={(value) => this.setState({ selectedFranchisee: null })}
                                                              name={(d) => [d.detail.customerCode, d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                                + (d.detail.name3 == null ? "" : d.detail.name3)
                                                                + (d.detail.name4 == null ? "" : d.detail.name4)]
                                                              } parser={(t, v, d) => {
                                                                return d.detail.name1 + (d.detail.name2 == null ? "" : d.detail.name2)
                                                                  + (d.detail.name3 == null ? "" : d.detail.name3)
                                                                  + (d.detail.name4 == null ? "" : d.detail.name4)
                                                              }
                                                              } data={this.state.loadingFranchisee} placeholder={Labels.GetLabel("generic.select")} />

                                                            {this.state.selectedFranchisee != null ?
                                                              <div>
                                                                {this.state.selectedFranchisee.mainCompany.personPermissionGroup.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div> :
                                                                  this.state.selectedFranchisee.mainCompany.personPermissionGroup.map(item => <div className="generics_listing_item" >
                                                                    <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
                                                                    <div className="generics_listing_content" >
                                                                      <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}{item.mainPerson.brand ? <span>{item.mainPerson.brand.label}</span> : null}</div>
                                                                      <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 9, "valueType", null, "Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 8, "valueType", null, " Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 7, "valueType", null, " ")}</div>
                                                                      <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.mainPerson.personValue, 3, "valueType", null, " Email:"))}
                                                                        <span>{Labels.GetLabel("permission." + item.logicalApGroups.name)}</span></div>
                                                                    </div>
                                                                  </div>)}
                                                              </div> : null}
                                                          </div>}
                                                      </div>
                                                  }
                                                </div>
                                              </Modal.Body>
                                              <Modal.Footer>
                                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                                </Button>
                                                <Button variant="primary" disabled={this.state.selectedStateGroup == null || this.state.selectedFranchisee == null} onClick={() => { this.downloadReport("franchisee", this.state.selectedFranchisee.detail.customerCode) }}>
                                                  {Labels.GetLabel("adminstategroup.savebtn")}
                                                </Button>
                                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                            </div>
                                            : this.state.isModalVisible == "file" ?
                                              <div>
                                                <Modal.Header>
                                                  <Modal.Title>{Labels.GetLabel("program.newfile")}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                  <Form>
                                                    <Form.Label>{Labels.GetLabel("generic.file")}</Form.Label>
                                                    <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                                                    <br />
                                                    <MaskedInput type="text" notnull={true} onValid={(value) => this.setState({ label: value })} label={Labels.GetLabel("generic.name")}
                                                      onInvalid={(value) => this.setState({ label: null })} />
                                                    <MaskedInput type="text" notnull={false} onValid={(value) => this.setState({ observation: value })} label={Labels.GetLabel("generic.observation")}
                                                      onInvalid={(value) => this.setState({ observation: null })} />
                                                  </Form>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                                  </Button>
                                                  <Button variant="primary" disabled={this.state.observation == null || this.state.file == null} onClick={() => this.addNewFile()}>
                                                    {Labels.GetLabel("adminstategroup.savebtn")}
                                                  </Button>
                                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                              </div>

                                              :
                                              this.state.isModalVisible == "delete" ?
                                                <div>
                                                  <Modal.Header>
                                                    <Modal.Title>{Labels.GetLabel("generic.delete")}</Modal.Title>
                                                  </Modal.Header>
                                                  <Modal.Body>
                                                    {Labels.GetLabel("generic.confirmdel")}
                                                    <br />
                                                  </Modal.Body>
                                                  <Modal.Footer>
                                                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                      {Labels.GetLabel("adminstategroup.closebtn")}
                                                    </Button>
                                                    <Button variant="primary" onClick={() => this.deleteItem()}>
                                                      {Labels.GetLabel("generic.confirm")}
                                                    </Button>
                                                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                                </div>
                                                :
                                                this.state.isModalVisible == "deleteprogram" ?
                                                  <div>
                                                    <Modal.Header>
                                                      <Modal.Title>{Labels.GetLabel("program.deleteprogram")}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                      {Labels.GetLabel("generic.confirmdel")}
                                                      <br />
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                                      </Button>
                                                      <Button variant="primary" onClick={() => this.deleteProgram()}>
                                                        {Labels.GetLabel("generic.confirm")}
                                                      </Button>
                                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                                  </div>
                                                  : this.state.isModalVisible == "changestatus" ?
                                                    <div>
                                                      <Modal.Header>
                                                        <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                                                      </Modal.Header>
                                                      <Modal.Body>
                                                        {

                                                          this.state.data.program.qualitativeAwardMultiplier == null ||
                                                            this.state.data.program.qualitativeAwardMultiplier == 0 ||
                                                            this.state.data.program.qualitativeAwardType == null ||
                                                            this.state.data.program.programPaymentType == null ||
                                                            this.state.data.program.dtProgramStart == null ||
                                                            this.state.data.program.dtProgramEnd == null ||
                                                            this.state.data.primaryRule == null ? Labels.GetLabel('program_state.norulesdesc') :
                                                            Labels.GetLabel("PROGRAM_STATUS_PROGRAM_WARNING." + (this.state.status.programStatus.keyConstant < 3 ? 3 : 6))
                                                        }
                                                        <br />
                                                      </Modal.Body>
                                                      <Modal.Footer>
                                                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                          {Labels.GetLabel("adminstategroup.closebtn")}
                                                        </Button>
                                                        {
                                                          this.state.data.program.qualitativeAwardMultiplier == null ||
                                                            this.state.data.program.qualitativeAwardMultiplier == 0 ||
                                                            this.state.data.program.qualitativeAwardType == null ||
                                                            this.state.data.program.programPaymentType == null ||
                                                            this.state.data.program.dtProgramStart == null ||
                                                            this.state.data.program.dtProgramEnd == null ||
                                                            this.state.data.primaryRule == null ? null :
                                                            <Button variant="primary" onClick={() => this.changeStatus()}>
                                                              {Labels.GetLabel("generic.confirm")}
                                                            </Button>
                                                        }
                                                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                                    </div>
                                                    :
                                                    <div>
                                                      <Modal.Header>
                                                        <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                                                      </Modal.Header>
                                                      <Modal.Body>
                                                        {Labels.GetLabel("clientsnew.confirmation")}
                                                      </Modal.Body>
                                                      <Modal.Footer>
                                                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                                          {Labels.GetLabel("adminstategroup.closebtn")}
                                                        </Button>
                                                        <Button variant="primary" onClick={() => this.addNew()}>
                                                          {Labels.GetLabel("adminstategroup.savebtn")}
                                                        </Button>
                                                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                                    </div>
                    }
                  </div>
                </Modal>
              </div>
        }
      </Container >
    );
  }
}